import React from 'react'
import MainNavigation from './MainNavigation'
import { NavContextProvider } from './useNavContext'
import { getMainNavigationMenu } from './getMainNavigationMenu'
import {
  JSONValue,
  prependHostName
} from '@toasttab/shared/src/utils/siteUtils'
import withNinetailedExperience from '@toasttab/shared/src/utils/Ninetailed/withNinetailedExperience'
import NT_NavController from '@toasttab/shared/src/components/Ninetailed/NT_NavController'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { NavControllerProps, SiteRegionTypes } from './ContentfulNavigation.d'

const NavController = ({
  headerContent,
  localizedEntries,
  packageName,
  siteId,
  siteMetadata
}: NavControllerProps) => {
  const { headerOverride } = usePageContext()

  // Use Ninetailed if we have a valid nt_experience for the Header Override
  if (headerOverride?.nt_experiences) {
    const props = {
      ...headerOverride,
      localizedEntries
    }
    return withNinetailedExperience(NT_NavController, { ...props }, false)
  }

  const siteRegion = headerContent.country.toLowerCase() as SiteRegionTypes

  const menus = headerContent?.navMenuItems
    ? [...headerContent.navMenuItems]
    : []

  //Prepend https://pos.toasttab.com for support.toasttab.com
  const navigationData =
    packageName === 'support'
      ? prependHostName(
          getMainNavigationMenu(menus, siteRegion) as unknown as JSONValue,
          siteMetadata.hostName
        )
      : getMainNavigationMenu(menus, siteRegion)

  const heapClasses = {
    login: `${siteRegion}_topnav_login`,
    mainNav:
      siteRegion === 'us' ? `topnav_entire_v` : `${siteRegion}_topnav_entire`,
    regionSwitcher: `${siteRegion}_topnav_region`,
    requestDemo: `${siteRegion}_topnav_demo`,
    restaurantSearch: `${siteRegion}_topnav_restaurants`
  }
  const navContext = {
    ...headerContent,
    heapClasses,
    localizedEntries,
    navigationData:
      typeof navigationData === 'string'
        ? JSON.parse(navigationData)
        : navigationData,
    siteId,
    siteRegion
  }

  return (
    <NavContextProvider value={navContext}>
      <MainNavigation />
    </NavContextProvider>
  )
}

export default NavController
